import groupBy from "lodash/groupBy";
import PropTypes from "prop-types";
import React from "react";
import Modal from "../../../../parts/modal-new";
import ToolTip from "../../../../parts/tooltip";
import DateInput from "../../../../parts/inputs/date-input";
import moment from "moment";
import submit from "submit-form";
import { getAthleteFromId } from "../../../coaching-portal/tasks/task-constants";
import SvgIcon from "../../../../parts/SvgIcon";

class ConfirmPush extends React.PureComponent {
  constructor(props, context) {
    super(props, context);
    this.state = {
      submited: false,
    };
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleSubmit(e) {
    e.preventDefault();
    if (this.state.submited) return;
    this.setState({ submited: true });
    const { query, coachOrganizationInformation, activeUser } =
      this.context.locals;
    const { athlete, cycle, program } = query;
    const date = document.getElementsByName("date")[0].value;
    const obj = { method: "POST" };
    if (date) {
      obj.body = { date };
    }

    const athleteForTask = !!coachOrganizationInformation
      ? getAthleteFromId(athlete, coachOrganizationInformation.athletes)
      : getAthleteFromId(athlete, activeUser.athletes);
    if (athleteForTask) {
      obj.body = { ...obj.body, athleteForTask };
    }

    submit(
      `/actions/cycle/push/${String(cycle)}/${String(program)}/${String(
        athlete
      )}`,
      obj
    );
  }

  render() {
    const { fullProgram, athlete: ath } = this.props;
    const { activeUser } = this.context.locals;
    const referAsClients = Boolean(activeUser.referAsClients);
    let defaultDate = moment.utc();
    if (fullProgram && fullProgram.sessions) {
      const weeks = groupBy(fullProgram.sessions, "week");
      defaultDate = defaultDate.add(Object.keys(weeks).length, "weeks");
    }

    return (
      <form onSubmit={this.handleSubmit}>
        <Modal className="Confirm-Push" title={"Confirm Push"}>
          <div className="body">
            <div className="columns">
              <div className="column" data-col="1/1">
                <h4>By pushing this program you confirm that:</h4>
                <ul className="confirm-push-implications">
                  <li>
                    Your {referAsClients ? "client" : "athlete"} will now see
                    the program in their account.
                  </li>
                  <li>
                    You will no longer be able to edit this program but you can
                    still duplicate it and edit the duplicated copy.
                  </li>
                  <li>
                    The {referAsClients ? "client" : "athlete"} will receive the
                    program. They will need to add it to their calendar before
                    you can view or edit the program in their calendar. This is
                    useful if you want to make updates throughout the program.
                  </li>
                </ul>
              </div>
            </div>
            <div className="foot mt-8">
              <div className="info">
                <h4 className="alt">Setup reminder for new program</h4>
                <ToolTip
                  id="reminder"
                  body={`A programming task will automatically be setup to remind you when ${ath.name} needs a new program. 
                We estimate the due date based on the number of weeks in the program. Adjust as you see fit. `}
                >
                  <SvgIcon src="/img/new-icons/question-circle.svg" />
                </ToolTip>
              </div>

              <DateInput
                name="date"
                altPosition
                placeholder="Due date"
                defaultValue={defaultDate.toDate()}
                min={moment()}
                alignRight="true"
              />
            </div>
          </div>

          <footer>
            <a
              role="button"
              data-button-type="secondary"
              data-action="cancel"
              className="cancel"
              href="/actions/refresh?modal="
            >
              Cancel
            </a>

            <button data-button-type="primary" type="submit">
              Confirm
            </button>
          </footer>
        </Modal>
      </form>
    );
  }
}

ConfirmPush.contextTypes = { locals: PropTypes.object };

export default ConfirmPush;
